package com.essntl.features.area.ui.allareas

import com.essntl.features.area.domain.model.AreaModel

sealed interface AllAreasEvent {
    data object GetAllAreas : AllAreasEvent
    data class AddArea(val a: AreaModel) : AllAreasEvent
    data class EditArea(val a: AreaModel) : AllAreasEvent
    data class DeleteArea(val a: AreaModel) : AllAreasEvent
}